import "./Home.css"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Link } from "react-router-dom";


export const Home = () => {
  return (
    <>
      <div className='home' id='home' >
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50} slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
        >
          <SwiperSlide ><img src="./image/slider/1.webp" alt="img" /></SwiperSlide>
          <SwiperSlide ><img src="./image/slider/2.webp" alt="img" /></SwiperSlide>
          <SwiperSlide ><img src="./image/slider/3.webp" alt="img" /></SwiperSlide>
        </Swiper>
      </div>
      {/* <div className="contenu" > */}
        {/* <h1>Bienvenue sur le site de l'association</h1> */}
        {/* <div className="container_image" >
          <Link to="https://www.facebook.com/groups/protection.enfants/?_rdc=1&_rdr" >
            <div className="image_and_title" >
              <img src="./image/icons/hands.png" alt="img" />
              <span>Solidarité <strong>Sociale</strong></span>
            </div>
          </Link>
          <Link to="https://www.facebook.com/groups/protection.enfants/?_rdc=1&_rdr" >
            <div className="image_and_title" >
              <img src="./image/icons/heart.png" alt="img" />
              <span>Protection <strong>D'Enfance</strong></span>
            </div>
          </Link>
          <Link to="/donner" >
            <div className="image_and_title" >
              <img src="./image/icons/receive.png" alt="img" />
              <span>Faire un <strong>Don</strong></span>
            </div>
          </Link> */}
          {/* <div className="image_and_title" >
            <img src="./image/icons/scholarship.png" alt="img" />
            <span>Programme de <strong>Bourses</strong></span>
          </div> */}
        {/* </div> */}
      {/* </div> */}
    </>

  )
}